<template>
    <div class="estimate-advance-table-area">
        <div style="text-align: center;" class="no-print">
            <el-radio-group v-model="activeName">
                <el-radio-button label="income">收入</el-radio-button>
                <el-radio-button label="payout">支出</el-radio-button>
            </el-radio-group>
        </div>
        <AdvanceIncomeTable
            v-if="activeName === 'income'"
            :is-loading="isLoading"
            :data="invoiceData"
            :estimatedAmount="estimatedInvoiceAmount"
            :estimatedProjectAmount="estimatedProjectAmount"
            @add="$emit('add', 'invoiceData')"
            @delete="index => $emit('delete', { index, target: 'invoiceData' })"
        />
        <AdvancePayoutTable
            v-if="activeName === 'payout'"
            :is-loading="isLoading"
            :data="paymentData"
            :estimatedAmount="estimatedPaymentAmount"
            @add="$emit('add', 'paymentData')"
            @delete="index => $emit('delete', { index, target: 'paymentData' })"
        />
    </div>
</template>

<script>
import AdvancePayoutTable from '@/components/dashboard/Finance/Analysis/EstimatePage/AdvancePayoutTable.vue';
import AdvanceIncomeTable from '@/components/dashboard/Finance/Analysis/EstimatePage/AdvanceIncomeTable.vue';

export default {
    props: {
        isLoading: Boolean,
        type: String,
        invoiceData: {
            type: Array,
            default: () => [],
        },
        paymentData: {
            type: Array,
            default: () => [],
        },
        data: {
            type: Array,
            default: () => [],
        },
        estimatedInvoiceAmount: { type: Number, default: 0 },
        estimatedPaymentAmount: { type: Number, default: 0 },
        estimatedProjectAmount: { type: Number, default: 0 },
    },
    components: { AdvancePayoutTable, AdvanceIncomeTable },
    data() {
        return {
            activeName: 'income',
        };
    },
};
</script>
<style lang="scss">
.estimate-advance-table-area {
    margin-top: 50px;

    .estimate-advance-table {
        .table-header {
            .total,
            .remain {
                font-size: 9pt;
                font-weight: normal;
            }
        }
    }
}
</style>
